







































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Home extends Vue {
  drawer = false;

  logout() {
    this.$store.state.firebase.auth().signOut()
      .then(() => {
        this.$router.push('/login');
      });
  }

  get authenticated() {
    return this.$store.getters.authenticated;
  }
}
